export const partnersRootPages = {
  path: 'partners',
  name: 'partners_page_route',
  children: [
    {
      path: 'elys',
      name: 'partners_elys_page_route',
      redirect: {
        name: 'partners_elys_dossiers_page_route'
      },
      component: () => import('@/views/partners/elys/TheElysPage.vue'),
      children: [
        {
          path: 'search',
          name: 'partners_elys_search_page_route',
          component: () =>
            import('@/views/partners/elys/subpages/ElysSearch.vue')
        },
        {
          path: 'deceased/:deceasedId',
          name: 'partners_elys_deceased_page_route',
          props: true,
          component: () =>
            import(
              '@/views/partners/elys/subpages/ElysDeceasedTransportViewPage.vue'
            )
        },
        {
          path: 'dossiers',
          name: 'partners_elys_dossiers_page_route',
          props: true,
          component: () =>
            import('@/views/partners/elys/subpages/ElysDossiers.vue')
        }
      ]
    },
    {
      path: 'enaos',
      name: 'partners_enaos_page_route',
      redirect: {
        name: 'partners_enaos_select_funeral_home_page_route'
      },
      component: () => import('@/views/partners/enaos/TheEnaosPage.vue'),
      children: [
        {
          path: '',
          name: 'partners_enaos_select_funeral_home_page_route',
          component: () =>
            import('@/views/partners/enaos/subpages/EnaosSelectFuneralHome.vue')
        },
        {
          path: ':funeralHomeId',
          redirect: {
            name: 'partners_enaos_sales_page_route'
          },
          children: [
            {
              path: 'sales',
              name: 'partners_enaos_sales_page_route',
              props: true,
              component: () =>
                import('@/views/partners/enaos/subpages/EnaosSales.vue')
            }
          ]
        }
      ]
    }
  ]
}
